<template>
  <div class="menu" style="padding: 0px">
    <div
      @click="toggleMenu"
      class="menu-close text-right"
      style="height: 45px; display: flex; align-items: center; justify-content: flex-end"
    >
      <a href="javascript:;">
        <img src="/static/img/close-icon.svg" class="mr-3" />
      </a>
    </div>
    <ul
      style="height: calc(100vh - 90px); overflow: hidden; overflow-y: auto; border-top: 1px solid rgb(0, 28, 78); border-bottom: 1px solid rgb(0, 28, 78)"
    >
      <li>
        <router-link :to="{name: 'Home'}">Anasayfa</router-link>
      </li>
      <li>
        <router-link :to="{name: 'News'}">Haberler</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Fixture'}">Maç Takvimi</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Ticket'}">Bilet ve Kombine</router-link>
      </li>
      <li>
        <router-link :to="{name: 'FanClub'}">Anadolu Efes Fan Club</router-link>
      </li>
      <li>
        <router-link :to="{name: 'SosyalSorumlulukProjeleri'}">Sosyal Sorumluluk Projeleri</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Team'}">Takım Kadrosu</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Statistics'}">Takım İstatistikleri</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Basket'}">Anadolu Efes TV</router-link>
      </li>
      <li>
        <router-link :to="{name: 'SinanErdem'}">Salona Nasıl Gidilir?</router-link>
      </li>
      
      <li v-if="$store.getters.isLogged">
        <router-link :to="{name: 'Account'}">Profilim</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Help'}">Yardım</router-link>
      </li>

      <li>
        <router-link :to="{name: 'Contact'}">İletişim</router-link>
      </li>
    </ul>

    <div
      style="padding-top: 0; height: 45px; display: flex; align-items: center; justify-content: flex-end"
      class="log-out fs-14 fc-1 font-weight-bold text-right mr-3"
      @click="signOut();"
      v-if="$store.getters.isLogged"
    >
      <img src="/static/img/arrow-right.svg" class="mr-2" />Çıkış Yap
    </div>

    <div
      style="padding-top: 0; height: 45px; display: flex; align-items: center; justify-content: flex-end"
      class="log-out fs-14 fc-1 font-weight-bold text-right mr-3"
      v-if="$store.getters.isLogged == false"
    >
      <div style="margin-right: 25px" @click="$router.push({name: 'Login'})">
        <img src="/static/img/arrow-right.svg" class="mr-2" />Giriş Yap
      </div>
      <div @click="$router.push({name: 'Register'})">
        <img src="/static/img/arrow-right.svg" class="mr-2" />Kayıt Ol
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Menu",
  methods: {
    toggleMenu() {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open");
      } else {
        $("body").addClass("menu-open");
      }
    },
    signOut() {
      localStorage.removeItem("user");
      this.$store.state.user = null;
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style>
.section--demo-2 .agile__dots {
  bottom: 10px;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.agile__actions {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.agile__dots {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  list-style: none;
  padding: 0;
  white-space: nowrap;
}

.section--demo-2 .agile__dot {
  margin: 0 10px;
}

.section--demo-2 .agile__dot {
  margin: 0 10px;
}

.section--demo-2 .agile__dot--current button,
.section--demo-2 .agile__dot:hover button {
  background-color: #fff;
}

.section--demo-2 .agile__dot button {
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 10px;
}

.section--demo-2 .agile__dot button {
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 10px;
}

.section--demo-2 .agile__dot--current button,
.section--demo-2 .agile__dot:hover button {
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue